// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queue-notice {
  max-width: 960px;
  margin: 16px auto 24px;
  padding: 12px 16px;
  border-left: 4px solid #3a89c9;
  border-radius: 6px;
  background: #eef7ff;
  color: #243b53;
  font-size: 15px;
  line-height: 1.5;
}

.queue-notice a {
  color: #1f6fb2;
  font-weight: 600;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/QueueNotice.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":[".queue-notice {\n  max-width: 960px;\n  margin: 16px auto 24px;\n  padding: 12px 16px;\n  border-left: 4px solid #3a89c9;\n  border-radius: 6px;\n  background: #eef7ff;\n  color: #243b53;\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.queue-notice a {\n  color: #1f6fb2;\n  font-weight: 600;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
